import { Vendor, VendorConfigMap } from './vendorTypes';

export const createVendorConfig = (configMap: VendorConfigMap) => ({
    resolve(vendor: Vendor) {
        const base = configMap.default;
        const override = configMap[vendor];

        return {
            components: {
                ...base.components,
                ...override?.components,
            },
            features: {
                ...base.features,
                ...override?.features,
            },
        };
    },
});
